export default [
  {
    path: '/admin/school-basic-data/major-type/index',
    name: 'M020060',
    component: () =>
      import('@/views/admin/school-basic-data/major-type/Index.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/school-basic-data/major/index',
    name: 'M020061',
    component: () => import('@/views/admin/school-basic-data/major/Index.vue'),
    meta: { layout: 'admin' },
  },
  {
    path: '/admin/school-basic-data/class/index',
    name: 'M020062',
    component: () => import('@/views/admin/school-basic-data/class/Index.vue'),
    meta: { layout: 'admin' },
  },
];
